import { RulesDocumentTeacherType } from "../../../types/Teacher";
import { put } from "../../../utils/axios-config";
import { RULES_DOCUMENT_TEACHER } from "../../../utils/constants";

export const updateTeacherRequiredDocument = async (data:RulesDocumentTeacherType) => {
    return await put<RulesDocumentTeacherType, string>(RULES_DOCUMENT_TEACHER, data);
};